
<template >
  <div>
    <div class="container p-5">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="form-label-group">
              <textarea
                type="text"
                rows="4"
                id="qr"
                class="form-control"
                placeholder="QR კოდი"
                autofocus="autofocus"
                v-model="qrData.qr"
                v-on:input="qrDeserialize()"
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="moduleNumber"
                class="form-control"
                placeholder="მოდულის ნომერი"
                autofocus="autofocus"
                v-model="qrData.moduleNumber"
                v-on:input="qrSerialize()"
              />
              <label for="moduleNumber">მოდულის ნომერი</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="serverCommandNumber"
                class="form-control"
                placeholder="სერვერის ბრძანების კოდი"
                autofocus="autofocus"
                v-model="qrData.serverCommandNumber"
                v-on:input="qrSerialize()"
              />
              <label for="serverCommandNumber">სერვერის ბრძანების კოდი</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="tranUniqNumber"
                class="form-control"
                placeholder="ტრანზაქციის უნიკალური ნომერი"
                autofocus="autofocus"
                v-model="qrData.tranUniqNumber"
                v-on:input="qrSerialize()"
              />
              <label for="tranUniqNumber">ტრანზაქციის უნიკალური ნომერი</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="tranUNumber"
                class="form-control"
                placeholder="ამ ტიპის ტრანზაქციის რიგითი ნომერი"
                autofocus="autofocus"
                v-model="qrData.tranUNumber"
                v-on:input="qrSerialize()"
              />
              <label for="tranUNumber"
                >ამ ტიპის ტრანზაქციის რიგითი ნომერი</label
              >
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="zAccountNumber"
                class="form-control"
                placeholder="Z ანგარიშის ნომერი,რომელშიც დარეგისტრირდა ტრანზაქცია"
                autofocus="autofocus"
                v-model="qrData.zAccountNumber"
                v-on:input="qrSerialize()"
              />
              <label for="zAccountNumber"
                >Z ანგარიშის ნომერი,რომელშიც დარეგისტრირდა ტრანზაქცია</label
              >
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="tranType"
                class="form-control"
                placeholder="ტრანზაქციის ტიპი"
                autofocus="autofocus"
                v-model="qrData.tranType"
                v-on:input="qrSerialize()"
              />
              <label for="tranType">ტრანზაქციის ტიპი</label>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="amount"
                class="form-control"
                placeholder="თანხა"
                autofocus="autofocus"
                v-model="qrData.amount"
                v-on:input="qrSerialize()"
              />
              <label for="amount">თანხა</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="inputUserName"
                class="form-control"
                placeholder="vat"
                autofocus="autofocus"
                v-model="qrData.vat"
                v-on:input="qrSerialize()"
              />
              <label for="vat">დღგ</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="tranDate"
                class="form-control"
                placeholder="ტრანზაქციის თარიღი და დრო ფორმატში YYMMDDHHMMSS"
                autofocus="autofocus"
                v-model="qrData.tranDate"
                v-on:input="qrSerialize()"
              />
              <label for="tranDate"
                >ტრანზაქციის თარიღი და დრო ფორმატში YYMMDDHHMMSS</label
              >
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="moduleStatus"
                class="form-control"
                placeholder="მოდულის სტატუსი"
                autofocus="autofocus"
                v-model="qrData.moduleStatus"
                v-on:input="qrSerialize()"
              />
              <label for="moduleStatus">მოდულის სტატუსი</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="lottaryNumber"
                class="form-control"
                placeholder="ლატარიის კოდი"
                autofocus="autofocus"
                v-model="qrData.lottaryNumber"
                v-on:input="qrSerialize()"
              />
              <label for="lottaryNumber">ლატარიის კოდი</label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="signature"
                class="form-control"
                placeholder="ხელმოწერა"
                autofocus="autofocus"
                v-model="qrData.signature"
                v-on:input="qrSerialize()"
              />
              <label for="signature">ხელმოწერა</label>
            </div>
          </div>
          <!--<div class="form-group">
            <div class="form-label-group">
              <input
                type="number"
                id="statusCode"
                class="form-control"
                placeholder="სტატუსის კოდი "
                autofocus="autofocus"
                v-model="qrData.statusCode"
                v-on:input="qrSerialize()"
              />
              <label for="statusCode">სტატუსის კოდი</label>
            </div>
          </div>-->
        </div>
        <div class="col-12 d-flex justify-content-center">
          <qrcode-vue :value="value" :size="size" level="L" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import QrcodeVue from "qrcode.vue";

export default {
  name: "qrGenerator",
  data() {
    return {
      value: null,
      size: 250,
      qrData: {
        qr: null,
        moduleNumber: null,
        serverCommandNumber: null,
        tranUniqNumber: null,
        tranUNumber: null,
        zAccountNumber: null,
        tranType: null,
        amount: null,
        vAT: null,
        tranDate: null,
        moduleStatus: null,
        lottaryNumber: null,
        signature: null,
        statusCode: null,
      },
    };
  },
  methods: {
    async qrDeserialize() {
      try {
        let result = await this.$http.qrDeserialize(this.qrData.qr);
        var qr = this.qrData.qr;
        this.value = qr;
        if (result.status === 200) {
          this.qrData = result.data.res;
          this.qrData.qr = qr;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        //console.log(error, result);
        //bus.$emit("error", error);
        bus.$emit("warning", "დაფიქსირდა შეცდომა");
      }
    },
    async qrSerialize() {
      try {
        let result = await this.$http.qrSerialize(this.qrData);

        if (result.status === 200) {
          this.qrData.qr = result.data.res;
          this.value = result.data.res;
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("warning", "დაფიქსირდა შეცდომა");
      }
    },
  },
  components: {
    QrcodeVue,
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/QRGenerator.vue